export const weights = {
  regular: 400,
  medium: 500,
  demiBold: 600,
};
